import { useState, useEffect } from 'react';
import axios from 'axios';

export const useLeaveTypes = () => {
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/leave/types`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(r => setLeaveTypes(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { leaveTypes, loading };
};
